import React, { useEffect, useState } from 'react'
import CustomTooltip from '../utilities/ToolTip'
import { QuestionMarkCircle } from '../../assets/images';
import Select from 'react-select'
import FormInput from '../../uicomponents/form-input/forminput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import DropdownButton from "react-bootstrap/lib/DropdownButton";
import MenuItem from "react-bootstrap/lib/MenuItem";

const LeadRoutingForm = ({ projectData, projectsAssociatedWithBrand, removeLeadTransfer, idx, item, getFormData, projectOptions, options, handleChangeOfTargetProject, handleChangeOfOutcomes, ...rest }) => {
    return (
        <div key={idx}>
            <div className='action_row top-pad-0'>
                <DropdownButton
                    bsSize='small'
                    title={<FontAwesomeIcon icon={faEllipsisVertical} />}
                    id="action"
                >
                    {/* <MenuItem eventKey="1" 
            >Edit</MenuItem> */}
                    <MenuItem eventKey="2"
                        disabled={idx == 0 ? true : false}
                        onSelect={() => removeLeadTransfer(idx)}
                    >Delete</MenuItem>
                </DropdownButton>
            </div>
            <div className='outcome_link_label'>
                <label>Outcomes Linked</label>
                <CustomTooltip placement={'right'} component={<img src={QuestionMarkCircle} className='helper_icon' />}
                    description={'List of terminal outcomes'} />
            </div>
            <Select options={options}
                key={`outcome-${idx}`}
                // isOptionDisabled={(option) => option.isDisabled}
                value={options && options.filter(obj => item && item.transferCriteria && item.transferCriteria.map(crit => crit.outcome).includes(obj.value))} // set selected values
                isMulti
                // name="outcome-linked"
                // classNamePrefix="select"
                onChange={(e) => {
                    getFormData('transferCriteria', Array.isArray(e) ? e.map(x => x.value) : [], idx)
                    handleChangeOfOutcomes(e, idx)
                }}
                isOptionDisabled={(option) => option.isDisabled}
            // disabled={true}
            />
            <div style={{ color: '#121212' }}>Only terminal outcomes are listed here</div>
            {/* <br/> */}
            <div className='outcome_link_label'>
                <label>Link to project</label>
                <CustomTooltip placement={'right'} component={<img src={QuestionMarkCircle} className='helper_icon' />}
                    description={'List of projects related to same client/brand'} />
            </div>
            <Select options={projectOptions}
                key={`project-${idx}`}
                value={projectOptions && projectOptions.filter(obj => item.targetProject == obj.value)}
                // name="outcome-linked"
                // classNamePrefix="select"
                onChange={(e) => {
                    handleChangeOfTargetProject(e)
                    getFormData('targetProject', e.value, idx)
                }}
                isOptionDisabled={(option) => option.isDisabled}
            />
            <div style={{ color: '#121212' }}>Only same brand projects are listed here</div>
            <br />
            <FormInput
                label="Enter Attempts"
                type='number'
                helperIcon={true}
                helperText={'No. of attempts count for each outcome'}
                key={`attempts`}
                onChange={(e) => {
                    // validateGoogleSheetLink(e.target.value)
                    getFormData('attempts', e.target.value, idx)
                }}
                value={item.attempts || ''}
            />
        </div>
    )
}

export default LeadRoutingForm